import { gateway } from 'libs/generated-grpc-web';
import { getFileExtension } from 'libs/util';

import { IFileDownloadStatus } from '@app/src/app/file/public_interfaces';

export interface IMingaFile {
  file: gateway.file_pb.FileDetails.AsObject;
  status?: IFileDownloadStatus;
}

export interface GroupFiles {
  hash: string;
  files: IMingaFile[];
}

export namespace MingaFiles {
  export function fromFilesResponse(msg: gateway.minga_pb.MingaFilesResponse): IMingaFile[] {
    const files = msg.getFileList().map(file => {
      const fileObj = file.toObject();
      return {
        file: fileObj,
        status: { fileKey: getStatusKey(fileObj) },
      };
    });

    return files;
  }

  // complete file name with extension
  export function getStatusKey(
    file: gateway.file_pb.FileDetails.AsObject | gateway.content_views_pb.ShortFileCardView.AsObject,
  ) {
    const fileName =
      file.name && file.fileExtension
        ? file.name + '.' + file.fileExtension
        : file.name + '.' + getFileExtension(file.filePath);
    return fileName;
  }
}
